export default __webpack_public_path__ + "static/media/bg_girl_large.fd914c5b.svg";